import * as mutationTypes from '@/store/mutation-types.js'

export default {
  name: 'info',
  data () {
    return {}
  },

  computed: {
    huidigversienummer () {
      return this.$store.state.versienummer
    },
    projectNaam () {
      return this.$store.state.projectNaam
    },
    serverLocatie(){
       return window.location.hostname
    }
  },
  beforeCreate() {
    // eslint-disable-next-line
    if (Object.keys(WISA).length === 0) {
      this.$router.push("/");
    }
  },
  mounted: function () {
    this.$store.commit(mutationTypes.SET_MENUBAR_ITEMS, {
      left: 'menu',
      title: 'Info',
      right: []
    })
  }
}
